export const NAVIGATION_BAR_HEIGHT_PX = 80
export const TABS_HEIGHT_PX = 50
export const EMBED_HEADER_HEIGHT_PX = 56
